import { render } from "./DeleteTagModal.vue?vue&type=template&id=6c617487"
import script from "./DeleteTagModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteTagModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/DeleteTagModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c617487"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c617487', __exports__)) {
    api.reload('6c617487', __exports__)
  }
  
  module.hot.accept("./DeleteTagModal.vue?vue&type=template&id=6c617487", () => {
    api.rerender('6c617487', render)
  })

}


export default __exports__